import React, { useEffect } from 'react'
import moment from 'moment'

import { formatDateTime } from '../../../utilities/helpers'

import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import { DateInputWrapper } from '../../DateInputWrapper'
import { TimeInputWrapper } from '../../TimeInputWrapper'

export default function DateTime({
  event,
  isEditable,
  handleChange,
  handleDateTbd,
  handleTimeTbd,
  setEventStart,
  eventStart,
}) {
  const dateTbd = Boolean(event?.date_tbd || event?.start_tbd)
  const timeTbd = dateTbd || Boolean(event?.time_tbd)

  useEffect(() => {}, [event])

  const publicSchedule = () => {
    if (dateTbd) return 'Date & Time TBD'
    if (!eventStart) return 'Select a date'
    const dateLabel = moment(eventStart).format('MMM D')
    if (timeTbd) return `${dateLabel} · Time TBD`
    if (!event?.display_start_time) return dateLabel
    return `${dateLabel} · ${formatDateTime(moment(eventStart), 'timeOnly')}`
  }

  return (
    <fieldset className="form-group">
      <legend>Event Date</legend>
      <Row>
        <Col>
          <DateInputWrapper
            id="event-start"
            isReadOnly={isEditable}
            setDate={setEventStart}
            selectedDate={eventStart}
            startDate={eventStart}
            size="sm"
          />
        </Col>
        <Col>
          <TimeInputWrapper
            id="event-start-time"
            isReadOnly={isEditable}
            setDate={setEventStart}
            selectedDate={eventStart}
            size="sm"
          />
        </Col>
      </Row>
      <Form.Check
        type="checkbox"
        className="form-check-display mt-4"
        id="event-date-tbd-checkbox"
      >
        <Form.Check.Input
          name="date_tbd"
          type="checkbox"
          disabled={isEditable}
          checked={dateTbd}
          onChange={(e) => handleDateTbd(e.target.checked)}
        />
        <div>
          <Form.Check.Label id="event-date-tbd-checkbox">
            Date is TBD
          </Form.Check.Label>
          <small className="form-check-text">
            Fans see Date &amp; Time TBD. The date and time above stay on the
            event for sorting, reporting, and inventory.
          </small>
        </div>
      </Form.Check>
      <Form.Check
        type="checkbox"
        className="form-check-display mt-4"
        id="event-time-tbd-checkbox"
      >
        <Form.Check.Input
          name="time_tbd"
          type="checkbox"
          disabled={isEditable || dateTbd}
          checked={timeTbd}
          onChange={(e) => handleTimeTbd(e.target.checked)}
        />
        <div>
          <Form.Check.Label id="event-time-tbd-checkbox">
            Time is TBD
          </Form.Check.Label>
          <small className="form-check-text">
            Fans see the date with Time TBD. The time above is kept as the
            internal estimate.
          </small>
        </div>
      </Form.Check>
      <Form.Check
        type="checkbox"
        className="form-check-display mt-4"
        id="event-start-display-checkbox"
      >
        <Form.Check.Input
          name="display_start_time"
          type="checkbox"
          disabled={isEditable || timeTbd}
          checked={!timeTbd && event?.display_start_time}
          onChange={(e) => {
            handleChange(e, e.target.checked)
          }}
        />
        <div>
          <Form.Check.Label id="event-start-display-checkbox">
            Display start time
          </Form.Check.Label>
          <small className="form-check-text">
            The start time of your event will be displayed to attendees
          </small>
        </div>
      </Form.Check>
      <p className="mt-4 info-text info-text-md">
        <span>
          The event date will be displayed as:
          <span className="ps-1 fw-medium">{publicSchedule()}</span>
        </span>
      </p>
    </fieldset>
  )
}
